import { format } from 'date-fns';

export function formatDate(dateString: string) {
  try{
    const c = new Date(dateString);
    return format(c , 'MMMM do, yyyy'); // Outputs: March 20th, 2023
  }catch(c){
    return dateString;
  }
}
